<template><div><dt-notice kind="warning" title="Use DtText over CSS Utilities" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
Reach for the <a href="/components/text" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">DtText</a> component before considering any typography utility.
</dt-notice>
<h2 id="sans-serif" tabindex="-1" class="d-docsite--header-2">Sans-Serif <a class="header-anchor d-link d-docsite--link d-link" href="#sans-serif" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-ff-sans</code> to apply a Sans-Serif font stack.</p>
<code-example source-code='&lt;p class=&quot;d-ff-sans&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-ff-sans">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="mono" tabindex="-1" class="d-docsite--header-2">Mono <a class="header-anchor d-link d-docsite--link d-link" href="#mono" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-ff-mono</code> to apply a Monospace font stack.</p>
<code-example source-code='&lt;p class=&quot;d-ff-mono&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-ff-mono">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="marketing" tabindex="-1" class="d-docsite--header-2">Marketing <a class="header-anchor d-link d-docsite--link d-link" href="#marketing" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Dialtone supports select marketing fonts and weights. Use the following combinations to apply the marketing font stack.</p>
<code-example source-code='&lt;p class=&quot;d-ff-marketing&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-ff-marketing">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="css-variables" tabindex="-1" class="d-docsite--header-2">CSS Variables <a class="header-anchor d-link d-docsite--link d-link" href="#css-variables" aria-hidden="true">#</a></h2>
<clamped-table-wrapper>
  <div>
    <table class="d-table dialtone-doc-table">
      <thead class="d-bgc-primary d-ps-sticky d-zi-base1 d-ibs-0">
        <tr>
          <th scope="col" class="d-p-0 d-bbw0 d-w40p"><div class="d-p-200 d-bb d-bbw1">Variable</div></th>
          <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Output</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{ var: varName, output } in fontFamily.slice(0, -1)">
          <td class="d-code--sm d-docsite-code">var(--ff-{{ varName }})</td>
          <td class="d-code--sm">{{ output }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</clamped-table-wrapper>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<clamped-table-wrapper>
  <div>
    <table class="d-table dialtone-doc-table">
      <thead class="d-bgc-primary d-ps-sticky d-zi-base1 d-ibs-0">
        <tr>
          <th scope="col" class="d-p-0 d-bbw0 d-w40p"><div class="d-p-200 d-bb d-bbw1">Class</div></th>
          <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Output</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{ var: varName, output } in fontFamily">
          <td class="d-code--sm d-docsite-code">.d-ff-{{ varName }}</td>
          <td class="d-code--sm">font-family: {{ output }} !important;</td>
        </tr>
      </tbody>
    </table>
  </div>
</clamped-table-wrapper>
</div></template>


<script setup>
  import { fontFamily } from '@data/type.json';
  import ClampedTableWrapper from '@baseComponents/ClampedTableWrapper.vue';
</script>